module.exports = __webpack_public_path__ + "img/electricCar-red.bfbfbb95.svg";